import controller_0 from '@symfony/ux-turbo/dist/turbo_controller.js';
export default {
  'symfony--ux-turbo--turbo-core': controller_0,
};